/**
 * HTTP エラーから Laravel 形式のバリデーションエラー（`{ field: string[] }`）を取り出す。
 *
 * NOTE: SDK の `HttpError` はデフォルト総称型が `Record<string, Record<string, string>>` で
 * Laravel の `string[]` 形と一致しないため、ここで正しい形へ寄せて取得する。
 *
 * NOTE: SDK はレスポンスをキャメルケースへ変換しないため、Laravel が返すキーは
 * `first_name` のようなスネークケースになる。react-hook-form のフィールド名
 * （キャメルケース）と突き合わせられるよう、トップレベルのキーをキャメルケースへ変換する。
 * `email` のような単語キーは変換しても変わらないため既存の利用箇所には影響しない。
 * 422 応答の `errors` を扱う各フォームで共通利用する。
 */
const snakeToCamel = (key: string): string =>
  key.replace(/_([a-z0-9])/gi, (_, char: string) => char.toUpperCase())

export const getValidationErrors = (
  error: unknown,
): Record<string, string[]> => {
  if (error && typeof error === 'object' && 'errors' in error && error.errors) {
    const errors = error.errors as Record<string, string[]>
    return Object.fromEntries(
      Object.entries(errors).map(([key, messages]) => [
        snakeToCamel(key),
        messages,
      ]),
    )
  }
  return {}
}
